import { render, staticRenderFns } from "./JobDocumentType.vue?vue&type=template&id=2a2e0bef&"
import script from "./JobDocumentType.vue?vue&type=script&lang=js&"
export * from "./JobDocumentType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports